import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { NetworkStatus } from '@cbridge-utils/network';
import { SpreadProfileAction } from './spreadProfile.action';
import { spreadProfileInitialState } from './spreadProfile.constant';

export const spreadProfileReducer = reducerWithInitialState(spreadProfileInitialState)
  .case(SpreadProfileAction.loadList.started, (state) => ({
    ...state,
    networkStatus: NetworkStatus.Started,
  }))
  .case(SpreadProfileAction.loadList.done, (state, { result }) => ({
    ...state,
    data: Object.fromEntries(result.map((item) => [item.id, item])),
    networkStatus: NetworkStatus.Done,
  }))
  .case(SpreadProfileAction.loadList.failed, (state) => ({
    ...state,
    networkStatus: NetworkStatus.Failed,
  }))
  .case(SpreadProfileAction.create.done, (state, { result }) => ({
    ...state,
    data: {
      ...state.data,
      [result.id]: result,
    },
  }))
  .case(SpreadProfileAction.update.done, (state, { params }) => ({
    ...state,
    data: {
      ...state.data,
      [params.id]: { ...state.data[params.id], ...params },
    },
  }))
  .case(SpreadProfileAction.remove.done, (state, { params }) => ({
    ...state,
    data: Object.fromEntries(
      Object.entries(state.data).filter(([key]) => key !== String(params.id)),
    ),
  }))
  .case(SpreadProfileAction.destroy, () => ({
    ...spreadProfileInitialState,
  }));
